var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.singleHeader)?_c('panel-actions-portal',[_c('orbit-toggle',{attrs:{"value":_vm.orbitEnabled,"current-agent":_vm.currentAgent,"icon-only":""},on:{"change":function($event){return _vm.$emit('change', $event)}}}),_vm._v(" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }